import { takeLatest, delay, takeEvery } from 'redux-saga'
import { put, select, take, call } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import { storeSync, fetchShareDataSync, previewSync, privateLibrarySync } from 'sync'
import { storeSelectors } from 'redux/selectors'
import callAny from './helpers/call_any'
import storeActions from 'redux/actions/storeActions'
import store_filter_selector from 'redux/selectors/store/store_filter_selector'
import store_filters_data_selector from 'redux/selectors/store/store_filters_data_selector'
import filterTypes from 'helpers/enums/filters/filterTypes'
import entityTypesEnum from 'helpers/enums/entityTypesNames'
import sessionTypes from 'helpers/enums/sessionTypes'
import formatError from './helpers/error_formatter'
import userDataJwtSelector from '../selectors/user/user_data_jwt_selector'

function collapseSubItems(items, prefix) {

	let newItems = []
	items.forEach( item => {
		item.type = '3'
		item.originalText = item.text
		item.text = prefix + item.text
		newItems.push(item)
		if (item.items) {
			newItems = newItems.concat(collapseSubItems(item.items[0].items, prefix + '--'))
			item.items = null
		}
	})

	return newItems
}

//This method formats nested indexes so they can be sorted as strings
function formatIndexValue(val) {
	val = val.toString()
	while (val.length < 3) {
		val = '0' + val
	}
	return val
}

// This method makes sure all nested indexes have the same length so they can be sorted as strings.
// For now it supports 10 nested levels which should be more than enough for our case
function completeIndexString(val, totalLength = 3 * 10) {
	while (val.length < totalLength) {
		val = val + '0'
	}
	return val
}

function formatFilters(category, filterType, parentEntityUID, item_index) {
	category.filterType = filterType
	if (category.items) {
		if (category.type === '3') {
			let newItems = [{entityUID: parentEntityUID + '--C', text: 'All Strands', type: '4', friendlyText: 'All Strands'}]
			newItems = newItems.concat(collapseSubItems(category.items, '--'))
			category.items = newItems
			category.displayType = '51'
		}
		category.items.forEach( (item, index) => {
			item.item_index = completeIndexString(item_index + formatIndexValue(index + 1))
			if (item.items) {
				formatFilters(item.items[0], filterType, item.entityUID, item_index + formatIndexValue(index + 1))
			}
		})
	}
}


function *initializeStore() {
	try {
		const response = yield callAny(storeSync.getFilters)
		let filterIndex = 1
		response.payload.standard.forEach(standard => {
			formatFilters(standard, standard.type, 0, `00${filterIndex}`)
			filterIndex++
		})
		response.payload.categories.forEach((category, index) => formatFilters(category, '1', 0, `00${filterIndex}${formatIndexValue(index + 1)}`))
		//Changing display type of Standards standard to 50
		response.payload.standard[0].displayType = '50'
		//console.log(response.payload)

		//response.payload.standard[0].items = response.payload.standard[0].items.splice(0, 2)
		//response.payload.standard = response.payload.standard.splice(0, 1)
		yield put(storeActions.filtersFetched(response.payload))
	} catch (error) {
		// console.log(error)
	}
}

function *setupFilters(action) {
	const filters = action.filters || []
	const query = action.query || ''
	let i
	const len = filters.length
	let tab = '0'
	for (i = 0; i < len; i += 1) {
		let storeFilterData = yield select(store_filter_selector, filters[i])
		tab = storeFilterData.tab
		if (!storeFilterData.filter) {
			const response = yield callAny(storeSync.getStandardByStrand, filters[i])
			formatFilters(response.payload.standard.items[0], '2', 0, '001999')
			yield put(storeActions.standardFetched(response.payload.standard))
			storeFilterData = yield select(store_filter_selector, filters[i])
			tab = storeFilterData.tab
		}
	}
	yield put(storeActions.updateFilters(filters, tab, query))
}

function *initializeStoreSearch() {
	while (true) {
		const action = yield take([
			actionTypes.STORE_SEARCH_INITIALIZE,
			actionTypes.STORE_CONNECTOR_STORE_TOPBAR_INITIALIZE,
			actionTypes.STORE_LANDING_INITIALIZE,
			actionTypes.STORE_SEARCH_ROUTE_INITIALIZE,
			actionTypes.STORE_FOLDER_INITIALIZE,
			actionTypes.STORE_PREVIEW_INITIALIZE,
			actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE,
		])
		try {
			yield initializeStore(action)
			yield setupFilters(action)
			yield take([actionTypes.STORE_RESET])
		} catch (error) {
			// console.log(error)
		}
	}
}

function *initializeSearchStoreForVideo(action) {
	try {
		const params = {
			query: action.search.q,
			filters: action.search.filters,
		}
		yield initializeStore()
		yield setupFilters(params)
	} catch (error) {
		// console.log(error)
	}
}

function equalFilters(currentFilters, newFilters) {
	if (newFilters.length !== currentFilters.length) {
		return false
	}
	let i = 0
	const len = newFilters.length
	while (i < len) {
		if (newFilters[i] !== currentFilters[i]) {
			return false
		}
		i += 1
	}
	return true
}

function *updateStoreSearch(action) {
	try {
		const currentFilters = yield select(store_filters_data_selector)
		if (currentFilters.query !== action.query || !equalFilters(currentFilters.selectedFilters, action.filters)) {
			yield setupFilters(action)
		}
	} catch (err) {
		// console.log('ERROR: ', err)
	}

}

function *storeFilterSelected(action) {
	try {
		const storeFilterData = yield select(store_filter_selector, action.id)
		if (storeFilterData.filter && storeFilterData.filter.type && storeFilterData.filter.type === filterTypes.STANDARDS_FILTER && !storeFilterData.filter.items) {
			const response = yield callAny(storeSync.getStandardsCategories, storeFilterData.filter.entityUID)
			formatFilters(response.payload.standard.items[0], '2', 0, '001999')
			yield put(storeActions.standardFetched(response.payload.standard))
		}
	} catch (error) {
		// console.log(error)
	}
}

function *storeInitializeCalatog() {
	try {
		const response = yield callAny(storeSync.getCatalog)
		yield put(storeActions.getResultsCatalogSuccess(response.payload))
	} catch (error) {
		yield put(storeActions.getResultsCatalogError())
	}
}

function *storePerformSearch() {
	try {
		const currentStore = yield select(storeSelectors.storeSearchPerformSearchSelector)
		const response = yield callAny(
			storeSync.getSearchResults,
			currentStore.query,
			currentStore.filters,
			currentStore.page,
			currentStore.lessonTypeFilter
		)
		yield put(storeActions.getResultsSuccess(response.payload.result.entities, currentStore.page, response.payload.result.more))
	} catch (error) {
		yield put(storeActions.getResultsError())
	}
}

function *filterSearch() {
	const storeFilterDelaySelector = yield select(storeSelectors.storeFilterSearchDelaySelector)
	// Retrocompatibility with OLD ANGULAR STORE, remove when 'STORE_NEW_ROUTES' get unused
	if (!storeFilterDelaySelector.autoSearch) {
		return
	}

	yield call(delay, 1)
	yield put({
		type: actionTypes.STORE_FILTERS_SEARCH,
	})
}

function *getStoreLessonShareData(action) {
	try {
		const response = yield callAny(fetchShareDataSync, action.entityUID, action.entityType, action.libraryUID)
		yield put({
			type: actionTypes.SHARE_VIEW_DATA_LOADED,
			payload: response.payload.data,
			entityType: action.entityType,
			entityUID: action.entityUID,
		})
	} catch (error) {
		yield put({
			type: actionTypes.SHARE_VIEW_DATA_FAILED,
		})
	}
}

function *getStoreFolderData() {
	try {
		const currentStore = yield select(
			storeSelectors.storeFolderPerformSearchSelector
		)
		const response = yield callAny(
			storeSync.getStoreFolderResults,
			currentStore.folderUID,
			currentStore.page,
		)
		yield put(storeActions.getFolderResultsSuccess(
			response.payload.result.title,
			response.payload.result.entities,
			currentStore.page,
			response.payload.result.more
		))
	} catch (error) {
		yield put(storeActions.getResultsError())
	}
}

function *getStorePreviewPageData(action) {
	try {
		let response
		switch (action.entity_type) {
			case entityTypesEnum.LESSON:
				response = yield callAny(previewSync.getPreview, action.entity_ID, 'id', null, action.fromStrand)
				break
			case entityTypesEnum.BUNDLE:
				response = yield callAny(previewSync.getBundle, action.entity_ID, 'id', null, action.fromStrand)
				break
			default:
				throw new Error(action.entity_type + ' is not a valid entity type')
		}
		yield put(storeActions.getStorePreviewPageSuccess(response.payload))
	} catch (error) {
		yield put(storeActions.getResultsError())
	}
}

function *addToPrivateLibrary(action) {
	try {
		const selected = yield select(storeSelectors.storeAddToPrivateLibrarySelector)
		yield callAny(privateLibrarySync.searchSaveEntities, action.libraryId, 0, false, selected.lessons, selected.bundles)
		yield put(storeActions.addToPrivateLibrarySuccess(action.libraryType, action.libraryId, selected.lessons || selected.bundles))
	} catch (error) {
		const formattedError = formatError(error)
		yield put(storeActions.addToPrivateLibraryFailed(formattedError, action.libraryType))
	}
}

// code repeated on my_library_sagas and private_library_sagas
function *launchSession(presentationUID, sessionType) {
	try {
		const jwt = yield select(userDataJwtSelector)
		return yield callAny(
			storeSync.launchSession,
			presentationUID,
			true,
			jwt,
			sessionType
		)
	} catch (error) {
		throw formatError(error)
	}
}

function *launchFrontOfTheClassroom(action) {
	try {
		const response = yield call(launchSession, action.presentation_uid, sessionTypes.FRONT_OF_CLASSROOM)
		yield put(storeActions.launchFrontOfTheClassroomSessionFetched(response))
	} catch (serverError) {
		yield put(storeActions.launchFrontOfTheClassroomSessionFailed(serverError))
	}
}

export default [
	initializeStoreSearch(),
	takeLatest([actionTypes.STORE_FILTER_SELECTED], storeFilterSelected),
	takeLatest([actionTypes.STORE_CONNECTOR_STORE_TOPBAR_UPDATE], updateStoreSearch),
	takeLatest([actionTypes.STORE_LANDING_INITIALIZE], storeInitializeCalatog),
	takeLatest([
		actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE,
		actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL,
		actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE,
		actionTypes.GAME_INITIALIZE_CREATION_TOOL,
		actionTypes.GAME_INITIALIZE_STANDALONE,
		actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL,
		actionTypes.DRAW_IT_INITIALIZE_STANDALONE,
		actionTypes.MATCHING_PAIRS_CT_INITIALIZE_ROUTE,
		actionTypes.MATCHING_PAIRS_INITIALIZE_STANDALONE,
	], initializeSearchStoreForVideo),
	takeLatest([
		actionTypes.STORE_SEARCH_ROUTE_INITIALIZE,
		actionTypes.STORE_SEARCH_ROUTE_UPDATE,
		actionTypes.STORE_SEARCH_GET_NEXT_PAGE,
		actionTypes.VIDEO_STORE_PICKER_INITIALIZED,
		actionTypes.VIDEO_STORE_PICKER_UPDATED,
		actionTypes.GAME_INITIALIZE_CREATION_TOOL,
		actionTypes.GAME_INITIALIZE_STANDALONE,
		actionTypes.GAME_UPDATE_CREATION_TOOL_SEARCH,
		actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL,
		actionTypes.DRAW_IT_INITIALIZE_STANDALONE,
		actionTypes.DRAW_IT_UPDATE_CREATION_TOOL_SEARCH,
		actionTypes.MATCHING_PAIRS_UPDATE_CREATION_TOOL_SEARCH,
		actionTypes.MATCHING_PAIRS_CT_INITIALIZE_ROUTE,
		actionTypes.MATCHING_PAIRS_INITIALIZE_STANDALONE,
	], storePerformSearch),
	takeLatest([
		actionTypes.STORE_FILTER_SELECTED,
		actionTypes.STORE_LESSON_TYPE_FILTER_SELECTED,
	], filterSearch),
	takeLatest([actionTypes.STORE_SEARCH_SHARE_LESSON], getStoreLessonShareData),
	takeLatest([actionTypes.STORE_FOLDER_INITIALIZE, actionTypes.STORE_FOLDER_GET_NEXT_PAGE], getStoreFolderData),
	takeEvery([actionTypes.STORE_PREVIEW_INITIALIZE], getStorePreviewPageData),
	takeLatest([actionTypes.STORE_ADD_LESSON_TO_PRIVATE_LIBRARY], addToPrivateLibrary),
	takeLatest(actionTypes.STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM, launchFrontOfTheClassroom),
]

export {
	getStoreLessonShareData,
	launchSession,
	launchFrontOfTheClassroom,
	storePerformSearch,
}
